import { Box, Flex, Text, Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { getStatusColor } from "common/utils/statusColor";
import { useState } from "react";

const CustomStatusDropdown = ({ statusOptions, defaultStatus, onStatusChange }) => {
    const [status, setStatus] = useState(defaultStatus);

    const handleStatusChange = (newStatus) => {
        setStatus(newStatus);
        if (onStatusChange) {
            onStatusChange(newStatus);
        }
    };

    return (
        <Menu>
            <MenuButton
                as={Button}
                variant="outline"
                border="1px solid"
                borderColor="gray.300"
                bg="white"
                px="12px"
                py="6px"
                borderRadius="8px"
                _hover={{ bg: "gray.100" }}
                rightIcon={<ChevronDownIcon />}
            >
                <Flex alignItems="center" gap="8px">
                    <Box borderRadius="50%" h="8px" w="8px" backgroundColor={getStatusColor(status)} />
                    <Text fontWeight="medium" fontSize="14px" color="black">
                        {status}
                    </Text>
                </Flex>
            </MenuButton>
            <MenuList boxShadow="lg" borderRadius="8px">
                {statusOptions.map((option) => (
                    <MenuItem key={option} onClick={() => handleStatusChange(option)} _hover={{ bg: "gray.100" }}>
                        <Flex alignItems="center" gap="8px">
                            <Box borderRadius="50%" h="8px" w="8px" backgroundColor={getStatusColor(option)} />
                            <Text fontSize="14px">{option}</Text>
                        </Flex>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export default CustomStatusDropdown;
